import CompanyWrapper from 'src/company/templates/components/CompanyWrapper';
import { Company } from 'src/secret-menu/hooks/useCompanies';
import { DataUploadFilesTable } from './DataUploadFilesTable';

export default function FilesTab() {
  return <CompanyWrapper contentComponent={FilesContent} />;
}

function FilesContent({ company }: { company: Company }) {
  return <DataUploadFilesTable company={company} />;
}
